import { useCallback, useState } from "react";

import {
  Collection,
  CreateAndUpdateCollectionResponse,
  GetCollectionsResponse,
} from "@/components/cart/types";

import { useApi } from "../useApi";

const useCartCollections = () => {
  const [items, setItems] = useState<Collection[]>([]);
  // This loading is only for get collections.
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const { apiGet, apiPost, apiPatch } = useApi();

  const getCollections = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await apiGet<GetCollectionsResponse>("/collections");
      if (response?.collections) {
        setItems(response.collections);
      } else {
        setError("Failed to load collections");
      }
    } catch (error) {
      console.error(error);
      setError("Failed to load collections");
    } finally {
      setLoading(false);
    }
  }, [apiGet]);

  const createCollection = useCallback(
    async (name: string, assetIds: string[]): Promise<string> => {
      const response = await apiPost<CreateAndUpdateCollectionResponse>(
        "/collections",
        {
          name,
          assetIds,
        }
      );
      if (response?.collectionId) {
        return response.collectionId;
      } else {
        throw new Error("failed to create a collection");
      }
    },
    [apiGet]
  );

  const updateCollection = useCallback(
    async (collectionId: string, assetIds: string[]): Promise<string> => {
      const response = await apiPatch<CreateAndUpdateCollectionResponse>(
        `/collections/${collectionId}`,
        {
          assetIds,
        }
      );
      if (response?.collectionId) {
        return response.collectionId;
      } else {
        throw new Error("failed to create a collection");
      }
    },
    [apiGet]
  );

  return {
    items,
    loading: loading,
    error,
    getCollections,
    createCollection,
    updateCollection,
  };
};

export default useCartCollections;
